import React, { useEffect, useRef } from "react";
import { Popover, Modal as BsModal } from "bootstrap";
import { useModal } from "../../context/ModalContext";
import "../../assets/styles/ModalInfo.css";
import Button from "../Button";

const ModalInfo = ({ data }) => {
  const { closeModal } = useModal();

  const progressBarRef = useRef(null);
  const popoverRef = useRef(null);

  const progress = data?.progress ?? null;

  const handleDismiss = () => {
    try {
      const el = document.getElementById("bootstrapModal");
      const instance = el ? BsModal.getInstance(el) || BsModal.getOrCreateInstance(el) : null;
      instance?.hide();
    } catch {}
    closeModal();
  };

  const handleCloseClick = (e) => {
    try {
      e?.preventDefault?.();
      // 1) Executa callback custom se existir
      data?.content?.button?.onClick?.();
    } catch {}
    handleDismiss();
  };

  // Mostro o popover sempre
  useEffect(() => {
    if (!progressBarRef.current) return;

    const instance = Popover.getOrCreateInstance(progressBarRef.current, {
      trigger: "manual",
      placement: "top",
      container: "body",
      html: true,
      customClass: "progress-popover",
      content: progress != null ? `${progress}% concluído` : "",
      offset: [0, 8],
    });
    instance.show();
    popoverRef.current = instance;

    return () => {
      try { instance.dispose(); } catch {}
      popoverRef.current = null;
    };
  }, []);

  useEffect(() => {
    const inst = popoverRef.current;
    if (!inst) return;

    const txt = progress != null ? `${progress}% concluído` : "";
    if (typeof inst.setContent === "function") {
      inst.setContent({ ".popover-body": txt });
      inst.update && inst.update();
    } else {
      inst.dispose();
      const el = progressBarRef.current;
      if (!el) return;
      const next = Popover.getOrCreateInstance(el, {
        trigger: "manual",
        placement: "top",
        container: "body",
        html: true,
        customClass: "progress-popover",
        content: txt,
        offset: [0, 8],
      });
      next.show();
      popoverRef.current = next;
    }
  }, [progress]);

  // Isso precisa ser a última coisa antes do return
  if (!data) return null;

  return (
    <div className="ModalInfo">
      <button
        type="button"
        className="btn-close ModalInfo__close"
        aria-label="Fechar"
        onClick={handleDismiss}
      />
      <div className="container mx-auto text-center">
        <div className="row justify-content-center">
          <div className="col-auto">
            <img src={data?.icon} alt={data?.title} style={{ maxWidth: "180px" }} />
          </div>
        </div>

        {progress != null && (
          <div className="row justify-content-center mt-4 mt-lg-5">
            <div className="col">
              <div style={{ position: "relative", width: "100%" }}>
                <div
                  className="progress"
                  style={{ borderRadius: "90px", overflow: "hidden" }}
                  role="progressbar"
                  aria-label="Progresso"
                  aria-valuenow={progress}
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  <div
                    ref={progressBarRef}
                    className="progress-bar"
                    style={{ width: `${progress}%` }}
                  />
                </div>

                  <div
                    className="progress-tooltip"
                    style={{
                      position: "absolute",
                      top: "-30px",
                      left: `${progress}%`,
                      transform: "translateX(-50%)",
                      background: "#274625",
                      color: "#fff",
                      padding: "2px 8px",
                      borderRadius: "9px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      whiteSpace: "nowrap"
                    }}
                  >
                    {progress}%
                  </div>
                </div>
              </div>
            </div>
          )}
        <div className="row justify-content-center align-items-center">
          <div className="col">
            <h3
              className="my-4 my-lg-5"
              dangerouslySetInnerHTML={{ __html: `<strong>${data.title}</strong>` }}
            />
            {data?.content?.box && (
              <div className="info-box">
                <h3><strong>{data.content.box.date}</strong></h3>
                <hr />
                <p className="m-0" dangerouslySetInnerHTML={{ __html: data.content.box.reception }} />
                <p dangerouslySetInnerHTML={{ __html: data.content.box.start }} />
                <hr />
                <p className="mb-4" dangerouslySetInnerHTML={{ __html: data.content.box.place }} />
                <a className="btn btn-purissima" href={data.content.box.mapLink} >Ver mapa</a>
              </div>
            )}
            {data?.content?.description && (
              <p dangerouslySetInnerHTML={{ __html: data.content?.description }} />
            )}
            {data?.content?.button && (
              <div className="mt-5">
                  <Button
                    classes="major"
                    label={data.content?.button.label}
                    onClick={handleCloseClick}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalInfo;
